import React, { useState } from "react";

import { AnimatePresence, useAnimation } from "framer-motion";

import MainTemplate from "@/components/Templates/MainTemplate";
import Divider from "@/components/Atoms/Divider";
import Post from "./Post";
import Comments from "./Comments";
import FloatingBanner from "./FloatingBanner";

import { useAppSelector } from "@/hooks/useRedux";
import useDisableIntercom from "@/hooks/useDisableIntercom";

import { PostWrapper } from "./style";

const PostDetails = () => {
  useDisableIntercom({});

  const controls = useAnimation();

  const {
    isLoading,
    error,
    data: postDetail,
  } = useAppSelector((state) => state.community);

  const [showFloatingBanner, setShowFloatingBanner] = useState(true);

  const showBanner = () => {
    controls.start({
      scale: [1, 1.05, 1],
      transition: {
        type: "spring",
        duration: 0.6,
        // repeat: Infinity,
        // repeatDelay: 3,
      },
    });
    setShowFloatingBanner(true);
  };

  const hideBanner = () => setShowFloatingBanner(false);

  const downloadLink = postDetail?.download_link;

  const onDownloadButtonClick = () => {
    if (downloadLink) window.open(downloadLink, "_blank");
  };

  const { comments } = postDetail || {};

  return (
    <MainTemplate
      error={error}
      hideLinks
      hideRibbon
      hideFooter
      appDownloadLink={downloadLink}
    >
      <PostWrapper>
        <Post postDetail={postDetail} showBanner={showBanner} />
        <Divider />
        <Comments comments={comments} showBanner={showBanner} />
        <AnimatePresence>
          {showFloatingBanner && (
            <FloatingBanner
              hideBanner={hideBanner}
              controls={controls}
              onDownloadButtonClick={onDownloadButtonClick}
            />
          )}
        </AnimatePresence>
      </PostWrapper>
    </MainTemplate>
  );
};

export default PostDetails;
